<template>
  <div>
    <v-container fluid>
      <v-row v-if="editedItem">
        <v-col cols="12" v-if="!isGuest">
          <v-card class="mx-auto" max-width="688" outlined :loading="loading">
            <div class="mt-1 mb-1">
              <v-row no-gutters>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        $t("components.miscellaneous.sharedTask.title")
                      }}</v-list-item-title>
                      <v-list-item-subtitle>
                        <span> {{ editedItem.name }}</span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        $t("components.miscellaneous.sharedTask.dueDate")
                      }}</v-list-item-title>
                      <v-list-item-subtitle>
                        <span v-if="editedItem.due_date">
                          {{
                            editedItem.due_date.slice(0, 10)
                              | moment("DD.MM.YYYY")
                          }}</span
                        >
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        $t("components.miscellaneous.sharedTask.duration")
                      }}</v-list-item-title>
                      <v-list-item-subtitle>
                        <span> {{ getDuration }}</span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        $t("components.miscellaneous.sharedTask.priority")
                      }}</v-list-item-title>
                      <v-rating
                        v-model="editedItem.priority"
                        length="4"
                        :readonly="true"
                      >
                        <template v-slot:item="props">
                          <v-icon
                            @click="props.click"
                            :color="props.isFilled ? 'primary' : ''"
                            v-text="`mdi-numeric-${props.index + 1}-box`"
                          ></v-icon>
                        </template>
                      </v-rating>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        $t("components.miscellaneous.sharedTask.comment")
                      }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        editedItem.description
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" class="mb-1">
          <v-card
            class="mx-auto mb-2"
            max-width="688"
            min-height="50"
            outlined
            :loading="loading"
            v-for="(checklist, index) in editedItem.checklists"
            :key="index"
          >
            <div>
              <checklist-details
                :key="index"
                :checklist-index="index"
                :checklist="checklist"
                :checklist-length="editedItem.checklists.length"
                @update:subtask-comment="updateSubtaskComment"
                :content-saved.sync="contentSaved"
                :shared="true"
                :disabled="checkFinishedTask"
                :is-guest="isGuest"
              ></checklist-details>

              <v-card
                class="mx-auto"
                max-width="688"
                flat
                v-if="checklist.attachments.length"
              >
                <v-list-item class="mt-1">
                  <v-list-item-content>
                    <v-list-item-title
                      v-if="checklist.attachments.length"
                      class="mb-1"
                      >{{
                        $t("components.miscellaneous.sharedTask.attachments")
                      }}</v-list-item-title
                    >
                    <v-list-item-action-text>
                      <template
                        v-for="(attachment, index) in checklist.attachments"
                      >
                        <v-row :key="index" no-gutters class="mt-2">
                          <v-col cols="auto">
                            <v-btn
                              :href="attachment.file_link"
                              class="pr-0"
                              :target="target"
                              icon
                              ><v-icon color="grey darken-2"
                                >mdi-file-image</v-icon
                              >
                              <v-list-item-subtitle
                                class="text-none subtitle-2 ml-2"
                                >{{ attachment.title }}</v-list-item-subtitle
                              ></v-btn
                            >
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col cols="auto">
                            <!-- <v-btn
                              icon
                              v-if="!checkFinishedTask"
                              @click="removeTaskAttachment(attachment, index)"
                              ><v-icon color="red">mdi-delete</v-icon></v-btn
                            > -->
                          </v-col>
                        </v-row>
                      </template>
                    </v-list-item-action-text>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </div>
          </v-card>
          <v-card
            class="mx-auto mb-2"
            max-width="688"
            min-height="50"
            outlined
            :loading="loading"
            v-if="editedItem.checklists.length === 0 && !loading"
          >
            <div>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-icon
                    ><v-icon>mdi-calendar-remove-outline </v-icon>
                    <span class="mt-1 ml-2">{{
                      $t("components.miscellaneous.sharedTask.noTasksAvailable")
                    }}</span></v-list-item-icon
                  >
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" class="mb-12" v-if="editedItem.attachments.length">
          <v-card class="mx-auto" max-width="688" outlined>
            <v-list-item class="mt-1">
              <v-list-item-content>
                <v-list-item-title
                  v-if="editedItem.attachments.length"
                  class="mb-1"
                  >{{
                    $t("components.miscellaneous.sharedTask.attachments")
                  }}</v-list-item-title
                >
                <v-list-item-action-text>
                  <template
                    v-for="(attachment, index) in editedItem.attachments"
                  >
                    <v-row :key="index" no-gutters class="mt-2">
                      <v-col cols="auto">
                        <v-btn
                          :href="attachment.file_link"
                          class="pr-0"
                          :target="target"
                          icon
                          ><v-icon color="grey darken-2">mdi-file-image</v-icon>
                          <v-list-item-subtitle
                            class="text-none subtitle-2 ml-2"
                            >{{ attachment.title }}</v-list-item-subtitle
                          ></v-btn
                        >
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="auto">
                        <v-btn
                          icon
                          v-if="!checkFinishedTask"
                          @click="removeTaskAttachment(attachment, index)"
                          ><v-icon color="red">mdi-delete</v-icon></v-btn
                        >
                      </v-col>
                    </v-row>
                  </template>
                </v-list-item-action-text>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center">
        <upload-tasks-file-dialog
          :dialog="uploadImageDialog"
          @close="uploadImageDialog.active = false"
          @added="handleUploadImageDialog"
          v-if="uploadImageDialog.active"
        ></upload-tasks-file-dialog>
      </v-row>
    </v-container>
    <v-card outlined class="bottom-navigation" elevation="10">
      <v-row no-gutters>
        <v-col cols="12">
          <v-row justify="space-between" align="start">
            <v-card flat class="ml-3">
              <v-card-subtitle v-if="!checkFinishedTask">
                <v-progress-circular
                  :size="20"
                  :width="3"
                  indeterminate
                  color="primary"
                  v-if="!contentSaved"
                >
                </v-progress-circular>
                <span class="ml-2" v-if="!contentSaved"
                  >{{ $t("components.miscellaneous.sharedTask.savingChanges") }}
                </span>
                <span class="ml-2" v-if="contentSaved"
                  >{{
                    $t("components.miscellaneous.sharedTask.allChangesSaved")
                  }}
                </span>
              </v-card-subtitle>
              <v-card-subtitle v-else>
                <span class="ml-2">{{
                  $t("components.miscellaneous.sharedTask.taskFinished")
                }}</span>
              </v-card-subtitle>
            </v-card>
            <v-card flat class="my-auto">
              <v-btn
                @click="uploadDialog"
                :disabled="checkFinishedTask"
                icon
                class="mr-8 btn-image"
              >
                <v-icon class="mr-2">mdi-image-plus</v-icon>
                <span class="hidden-xs-only">{{
                  $t("components.miscellaneous.sharedTask.uploadImage")
                }}</span>
              </v-btn>
              <v-btn
                @click="finish"
                :disabled="checkFinishedTask"
                icon
                class="mr-8 btn-reset"
              >
                <v-icon class="mr-2">mdi-lock</v-icon>
                <span class="hidden-xs-only">{{
                  $t("components.miscellaneous.sharedTask.finishTask")
                }}</span>
              </v-btn>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <warning-dialog
      :dialog="finishTaskDialog.active"
      :text="finishTaskDialog.text"
      :title="finishTaskDialog.title"
      @agree="handleFinishDialogOutput"
      :confirm="$t('components.miscellaneous.sharedTask.yes')"
      :reject="$t('components.miscellaneous.sharedTask.cancel')"
      v-show="false"
    />
  </div>
</template>

<script>
import snackbar from "@/utils/snackbar";
import api from "@/utils/api";
import UploadTasksFileDialog from "@/components/dialogs/UploadTasksFileDialog";
import WarningDialog from "@/components/dialogs/WarningDialog.vue";
import { mapGetters, mapState } from "vuex";
import ChecklistDetails from "@/components/checklists/ChecklistDetails.vue";
export default {
  components: {
    UploadTasksFileDialog,
    WarningDialog,
    ChecklistDetails,
  },
  data() {
    return {
      finishTaskDialog: { active: false, title: "", text: "" },
      uploadImageDialog: { active: false },
      editedItem: { checklists: [], reports: [], attachments: [] },
      contentSaved: true,
      loading: true,
      isGuest: false,
      durations: [],
    };
  },
  created() {
    this.setInitialData();
    if (
      typeof this.$route.query.target !== "undefined" &&
      this.$route.query.target === "GUEST"
    ) {
      this.isGuest = true;
    }
    this.loading = true;
    api.getSharedTask(this.$route.params.id).then((resp) => {
      this.handleTaskData(resp);
      this.loading = false;
    });
  },
  computed: {
    ...mapGetters(["getIframeStatus"]),
    target() {
      return !this.getIframeStatus ? "_blank" : "";
    },
    checkFinishedTask() {
      return !!this.editedItem.completed;
    },
    getDuration() {
      let duration = this.durations.find(
        (item) => item.value === this.editedItem.duration
      );
      return typeof duration === "undefined"
        ? this.editedItem.duration
        : duration.duration;
    },
    modelPresent() {
      return !!this.editedItem.crm_boat;
    },
  },
  methods: {
    setInitialData() {
      this.durations = [
        {
          duration: this.$t("components.miscellaneous.sharedTask.15m"),
          value: 15,
        },
        {
          duration: this.$t("components.miscellaneous.sharedTask.30m"),
          value: 30,
        },
        {
          duration: this.$t("components.miscellaneous.sharedTask.45m"),
          value: 45,
        },
        {
          duration: this.$t("components.miscellaneous.sharedTask.1h"),
          value: 60,
        },
        {
          duration: this.$t("components.miscellaneous.sharedTask.2h"),
          value: 120,
        },
        {
          duration: this.$t("components.miscellaneous.sharedTask.4h"),
          value: 240,
        },
        {
          duration: this.$t("components.miscellaneous.sharedTask.8h"),
          value: 480,
        },
        {
          duration: this.$t("components.miscellaneous.sharedTask.12h"),
          value: 720,
        },
        {
          duration: this.$t("components.miscellaneous.sharedTask.16h"),
          value: 960,
        },
        {
          duration: this.$t("components.miscellaneous.sharedTask.24h"),
          value: 1440,
        },
      ];
    },
    updateSubtaskComment(subtask) {
      let index = this.editedItem.checklists[subtask.index].subtasks.findIndex(
        (element) => subtask.uuid === element.uuid
      );
      if (!subtask.active) {
        this.$set(
          this.editedItem.checklists[subtask.index].subtasks[index],
          "active",
          true
        );
      } else {
        this.$set(
          this.editedItem.checklists[subtask.index].subtasks[index],
          "active",
          false
        );
      }
    },
    handleFinishDialogOutput(status) {
      if (status) {
        api
          .finishSharedTask(this.$route.params.id)
          .then((resp) => {
            snackbar.success(
              this.$t("utils.snackbar.success.taskSuccessfullyFinished")
            );
            this.handleTaskData(resp);
          })
          .catch((err) => {
            this.handleError(err.response);
          });
      }
      this.finishTaskDialog.active = false;
    },
    removeTaskAttachment(obj, index) {
      let attachment_uuids = this.editedItem.attachments
        .filter((item) => item.uuid !== obj.uuid)
        .map((item) => item.uuid);

      api
        .updateSharedTask(this.$route.params.id, {
          attachment_uuids: attachment_uuids,
        })
        .then(() => {
          this.editedItem.attachments.splice(index, 1);
        });
    },

    handleUploadImageDialog(event) {
      event.forEach((element) => {
        this.editedItem.attachments.push(element);
      });
      this.uploadImageDialog.active = false;
    },

    uploadDialog() {
      this.uploadImageDialog.active = true;
    },

    handleTaskData(resp) {
      this.editedItem = resp.data;
      this.editedItem.checklists.forEach((checklist) => {
        checklist.subtasks = checklist.subtasks.map((subtask) => {
          return {
            ...subtask,
            active: !!(subtask.comment && subtask.comment.length !== 0),
          };
        });
      });
      this.editedItem.priority = Number(this.editedItem.priority);
      this.loading = false;
    },

    finish() {
      this.finishTaskDialog.active = true;
      this.finishTaskDialog.title = this.$t(
        "components.miscellaneous.sharedTask.areYouSureYouWantToFinishTheTask"
      );
    },
  },
};
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
.btn-reset:hover {
  color: red;
}
.btn-image:hover {
  color: var(--primary);
}
.bottom-navigation {
  position: fixed;
  bottom: 0;
  right: 0;
  height: 54px;
  width: 100%;
  color: white;
}
</style>
